import React, { useState, useEffect, useRef } from "react";
import "handsontable/dist/handsontable.full.min.css";
import { HotTable } from "@handsontable/react";
import { registerAllModules } from "handsontable/registry";
import { Grid } from "@material-ui/core";
import axios from "axios";

registerAllModules();

function GL_Table_Detail_HR({ formState, setGLAccountTotal }) {
  const [headers, setHeaders] = useState([]);
  const hotRef = useRef(null);
  const [columns, setColumns] = useState([]);
  const fsCols = ["FS Doc", "FS Doc Date"];
  const columnHeaders = [
    "GL Account",
    "Amount",
    "Horizon Id",
    "Vendor Code",
    "Department",

    "CostCenter",
    "CC Owner Code",
    "CC Owner",
    "Profit Center",
  ];
  useEffect(() => {
    const cols = formState?.invoiceCategory.includes("Final Settlement")
      ? [...fsCols, ...columnHeaders]
      : columnHeaders;
    setHeaders(cols);
  }, [formState?.invoiceCategory]);

  useEffect(() => {
    const finalSettelmentAdditionalCol = [
      {
        // data: "FS Doc",
        data: "fsDocNo",
        width: 200,
        type: "text",
      },
      {
        // data: "FS Doc Date",
        data: "fsDocDate",
        width: 200,
        type: "date",
        dateFormat: "YYYY-MM-DD",
      },
    ];

    const data = [
      {
        data: "glAccount",
        type: "autocomplete",
        source: function (query, proces) {
          // var _data = { 'query': query };
          let _gl = "";
          if (query != null && query != "" && query.split("-").length == 1) {
            _gl = query.split("-")[0];
          }
          axios({
            method: "get", //you can set what request you want to be
            url: `${
              process.env.REACT_APP_API_URL
            }/api/Invoices/GetChargeAccount_v1/${_gl ? _gl : -1}`,
            headers: {
              Authorization: `Bearer ${localStorage.getItem("user_token")}`,
              "Content-Type": "application/json",
            },
          })
            .then((response) => {
              proces(
                response.data.map(function (m) {
                  return m.GLAccount + " - " + m.ShortText;
                })
              );
            })
            .catch(function (err) {
              console.log(err);
            });
        },
        strict: false,
        width: 300,
      },
      {
        data: "amount",
        width: 200,
        type: "numeric",
        numericFormat: {
          pattern: "0,0.00",
          culture: "en-US", // this is the default culture, set up for USD
        },
      },
      {
        data: "horizonId",
        type: "autocomplete",
        source: function (query, proces) {
          // var _data = { 'query': query };
          let hi = "";
          if (query != null && query != "" && query.split("-").length == 1) {
            hi = query.split("-")[0];
          }
          axios({
            method: "get", //you can set what request you want to be
            url: `${
              process.env.REACT_APP_API_URL
            }/api/Invoices/GetEmployeeList_v1/${hi ? hi : null}`,
            headers: {
              Authorization: `Bearer ${localStorage.getItem("user_token")}`,
              "Content-Type": "application/json",
            },
          })
            .then((response) => {
              proces(
                response.data.map(function (m) {
                  return m.employeeCode + " - " + m.employeeName;
                })
              );
            })
            .catch(function (err) {
              console.log(err);
            });
        },
        strict: false,
        width: 300,
      },
      {
        data: "vendorCode",
        type: "autocomplete",
        source: function (query, proces) {
          // var _data = { 'query': query };
          let _gl = "";
          if (query != null && query != "" && query.split("-").length == 1) {
            _gl = query.split("-")[0];
          }
          axios({
            method: "get", //you can set what request you want to be
            url: `${
              process.env.REACT_APP_API_URL
            }/api/InvoiceDetails/getVendorDetails/${_gl ? _gl : -1}`,
            headers: {
              Authorization: `Bearer ${localStorage.getItem("user_token")}`,
              "Content-Type": "application/json",
            },
          })
            .then((response) => {
              proces(
                response.data.map(function (m) {
                  return m.Vendor_Code + " - " + m.Vendor_Name;
                })
              );
            })
            .catch(function (err) {
              console.log(err);
            });
        },
        strict: false,
        width: 300,
      },
      {
        data: "department",
        width: 200,
        type: "text",
      },
      {
        data: "costCenter",
        type: "autocomplete",
        source: function (query, proces) {
          var data = { query: query };
          let _ca = "";
          if (query != null && query != "" && query.split("-").length == 1) {
            _ca = query.split("-")[0];
          }
          axios({
            method: "get", //you can set what request you want to be
            url: `${
              process.env.REACT_APP_API_URL
            }/api/Invoices/GetCostCenters_v1/${_ca ? _ca : "-1"}`,
            headers: {
              Authorization: `Bearer ${localStorage.getItem("user_token")}`,
              "Content-Type": "application/json",
            },
          })
            .then((response) => {
              proces(
                response.data.map(function (m) {
                  return m.CostCenterCode + " - " + m.Name;
                })
              );
            })
            .catch(function (err) {
              console.log(err);
            });
        },
        strict: false,
        width: 180,
      },
      {
        data: "costCenterOwner",
        width: 1,
        type: "text",
        readOnly: true,
      },
      {
        data: "costCenterOwnerName",
        width: 240,
        type: "text",
        readOnly: true,
      },

      {
        data: "profitCenter",
        width: 110,
        type: "text",
      },
    ];

    const cols = formState?.invoiceCategory.includes("Final Settlement")
      ? [...finalSettelmentAdditionalCol, ...data]
      : data;

    setColumns(cols);
  }, [formState?.invoice_Accounts]);

  const calculateTotalGLAmount = () => {
    const totalGLAmount = formState?.invoice_Accounts?.reduce(
      (accumulator, currentValue) => {
        const amountWithoutCommas = String(currentValue?.amount).replace(
          /,/g,
          ""
        );
        const numericAmount = Number(Number(amountWithoutCommas)?.toFixed(2));

        return accumulator + numericAmount;
        // return accumulator + Number(Number(currentValue?.amount)?.toFixed(2));
      },
      0
    );
    return totalGLAmount;
  };
  const totalAmount = calculateTotalGLAmount();
  return (
    <>
      <HotTable
        data={formState?.invoice_Accounts || []}
        colHeaders={
          formState?.invoiceCategory.includes("Final Settlement")
            ? [...fsCols, ...columnHeaders]
            : columnHeaders
        }
        columns={columns}
        manualRowResize={true}
        manualColumnResize={true}
        rowHeaders={true}
        height="200"
        rowHeaderWidth={25}
        contextMenu={true}
        filters={true}
        width="100%"
        hiddenColumns={{
          indicators: true,
          columns: formState?.invoiceCategory.includes("Final Settlement")
            ? [8]
            : [6],
        }}
        readOnly={true}
        dropdownMenu={true}
        ref={hotRef}
        licenseKey="non-commercial-and-evaluation" // for non-commercial use
      />
      <Grid container spacing={0} mt={1}>
        <Grid item sm={6} md={3} lg={1}>
          <b>Total GL Amount:</b>
        </Grid>
        <Grid item sm={6} md={3} lg={2} style={{ paddingLeft: "4px" }}>
          <b>
            {totalAmount?.toLocaleString() || 0.0}
            {/* {addZeroes(
                  formState?.invoice_Accounts
                    ?.map((data) => data.amount)
                    .reduce((prev, curr) => Number(prev) + Number(curr), 0)
                )} */}
          </b>
        </Grid>
      </Grid>
    </>
  );
}

export default GL_Table_Detail_HR;
